/**
 * انتخابِ چند تگ از یه فهرست، با جستجو — قرینه‌ی
 * apps/mobile/src/ui/TagMultiSelect.tsx.
 *
 * خودِ رفتار (سطرِ جمع‌شده با چیپ‌های ضربدردار + فهرستِ بازشوی جستجودار) در
 * `MultiSelect` است و بین تگ و دوستان مشترک؛ این‌جا فقط چیزهای تگ می‌مونه:
 * برچسبِ دوزبانه و جستجویی که فارسی و انگلیسی و slug رو با هم می‌بینه
 * (core/lib/tagFilter) — کسی که اپش فارسیه ولی «rock» تایپ می‌کنه هم باید
 * تگِ 🎸 راک رو پیدا کنه.
 */
import React from 'react';
import { t } from '@/core/lib/i18n';
import { filterTags } from '@/core/lib/tagFilter';
import { tagLabel } from '@/core/lib/tagLabel';
import type { Tag } from '@/core/domain/types';
import { MultiSelect, type PickItem } from './MultiSelect';

export function TagPicker({ value, onChange, tags }: {
  value: number[];
  onChange: (ids: number[]) => void;
  tags: Tag[];
}) {
  const items: PickItem[] = tags.map((tag) => ({ key: String(tag.id), label: tagLabel(tag) }));
  const byKey = new Map(tags.map((tag) => [String(tag.id), tag]));

  return (
    <MultiSelect
      logKey="tag"
      placeholder={t('pickTags')}
      value={value.map(String)}
      items={items}
      // جستجو روی خودِ تگ‌ها انجام می‌شه نه روی برچسبِ ساخته‌شده، تا هر دو
      // زبان و slug دیده بشن.
      filter={(all, q) => {
        const keep = new Set(filterTags(tags, q).map((tag) => String(tag.id)));
        return all.filter((it) => keep.has(it.key));
      }}
      onToggle={(key) => {
        const id = byKey.get(key)!.id;
        onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
      }} />
  );
}
